import { useState } from "react";

export function useValidacionFormulario(datos) {
  const [errores, setErrores] = useState({});

  //----------------------------------------------------------------------------------
  const esVacio = (valor) => {
    if (valor === null || valor === undefined) return true;

    // Strings
    if (typeof valor === "string") {
      return valor.trim() === "" || valor === "0";
    }

    // Números
    if (typeof valor === "number") {
      return valor === 0;
    }

    return false;
  };

  //----------------------------------------------------------------------------------
  const validarCampos = (camposObligatorios) => {
    const nuevosErrores = {};

    camposObligatorios.forEach((campo) => {
      nuevosErrores[campo] = esVacio(datos[campo]);
    });

    setErrores(nuevosErrores);

    return !Object.values(nuevosErrores).some(Boolean);
  };

  //----------------------------------------------------------------------------------
  const limpiarError = (campo) => {
    setErrores((prev) => ({
      ...prev,
      [campo]: false,
    }));
  };

  const tieneError = (campo) => Boolean(errores[campo]);

  const claseLabel = (campo) =>
    tieneError(campo) ? "text-red-600" : "";

  const claseCampo = (campo) =>
    tieneError(campo)
      ? "!border-red-600 focus:!border-red-600 focus:!ring-red-600"
      : "";

  return {
    errores,
    validarCampos,
    limpiarError,
    tieneError,
    claseLabel,
    claseCampo,
  };
}